import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../../service/getNumberOfLayers"
import resolveAdhesiveSideName from "../../../../../service/sideNameResolver/resolveAdhesiveSideName"
import type { OneClickFieldProps } from "../../../../../types"
import FieldSet from "../../../../components/1Click/FieldSet"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./rfContactPortionCnt.png"

const 端子部厚み指定 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const isSpecifiedOneOrMore =
    values.rfContactPortionCnt === ESTIMATE_CONSTANT.端子部厚み指定["1箇所"].value ||
    values.rfContactPortionCnt === ESTIMATE_CONSTANT.端子部厚み指定["2箇所"].value ||
    values.rfContactPortionCnt === ESTIMATE_CONSTANT.端子部厚み指定["3箇所以上"].value
  const condition = getDisplayCondition(values)
  const { rfContactPortionCnt: shouldShow } = condition
  const shouldShow端子部厚み指定1箇所目 = condition.rfContactPortion1 && condition.rfContactPortionBonding1
  const shouldShow端子部厚み指定2箇所目 = condition.rfContactPortion2 && condition.rfContactPortionBonding2

  return (
    <OneClickField
      isShow={shouldShow}
      legend="端子部厚み指定"
      helpURL={HELP_LINKS.端子部厚み指定}
      src={img}
      mapChildren
    >
      <>
        <RadioGroup
          name={FIELD_NAMES.端子部厚み指定}
          selectedValue={values.rfContactPortionCnt}
          onChange={handlers.radio}
        >
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.端子部厚み指定.なし.value}>なし</Radio>
            <Radio value={ESTIMATE_CONSTANT.端子部厚み指定["1箇所"].value}>1箇所</Radio>
            <Radio value={ESTIMATE_CONSTANT.端子部厚み指定["2箇所"].value}>2箇所</Radio>
            <Radio value={ESTIMATE_CONSTANT.端子部厚み指定["3箇所以上"].value}>3箇所以上</Radio>
          </OneClickFieldStack>
        </RadioGroup>
        <OneClickFieldMessages error={errors?.rfContactPortionCnt}>
          {isSpecifiedOneOrMore && (
            <p>
              ※ご注文の際は、①該当する端子部箇所と、それに対する②コネクタ品番、③端子部厚みの指示図が必要となります。
            </p>
          )}
        </OneClickFieldMessages>
      </>

      {shouldShow端子部厚み指定1箇所目 && (
        <_端子部厚み指定
          values={values}
          handlers={handlers}
          number={1}
          仕上り厚み指定={{
            name: FIELD_NAMES["仕上り厚み指定（1箇所目）"],
            selectedValue: values.rfContactPortion1,
            error: errors?.rfContactPortion1,
          }}
          接着面={{
            name: FIELD_NAMES["端子部厚み指定 接着面（1箇所目）"],
            selectedValue: values.rfContactPortionBonding1,
            error: errors?.rfContactPortionBonding1,
          }}
        />
      )}
      {shouldShow端子部厚み指定2箇所目 && (
        <_端子部厚み指定
          values={values}
          handlers={handlers}
          number={2}
          仕上り厚み指定={{
            name: FIELD_NAMES["仕上り厚み指定（2箇所目）"],
            selectedValue: values.rfContactPortion2,
            error: errors?.rfContactPortion2,
          }}
          接着面={{
            name: FIELD_NAMES["端子部厚み指定 接着面（2箇所目）"],
            selectedValue: values.rfContactPortionBonding2,
            error: errors?.rfContactPortionBonding2,
          }}
        />
      )}
    </OneClickField>
  )
}

export default 端子部厚み指定

type Props = OneClickFieldProps & {
  number: 1 | 2
  仕上り厚み指定: {
    name: string
    selectedValue: string
    error?: string
  }
  接着面: {
    name: string
    selectedValue: string
    error?: string
  }
}

const _端子部厚み指定 = ({ values, handlers, number, 仕上り厚み指定, 接着面 }: Props) => {
  const numberOfLayers = getNumberOfLayers(values)

  const id = (() => {
    if (numberOfLayers === 1) return "片面"
    if (numberOfLayers === 2) return "2層"
    if (numberOfLayers === 3) return "3層"
    if (numberOfLayers === 4) return "4層"
  })()
  if (!id) return null

  return (
    <>
      <FieldSet legend={`仕上り厚み指定 （${number}箇所目）`}>
        <RadioGroup name={仕上り厚み指定.name} selectedValue={仕上り厚み指定.selectedValue} onChange={handlers.radio}>
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.仕上り厚み指定["0.2±0.03mm"].value}>0.2±0.03m</Radio>
            <Radio value={ESTIMATE_CONSTANT.仕上り厚み指定["0.3±0.03mm"].value}>0.3±0.03mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.仕上り厚み指定["0.12±0.02mm"].value}>0.12±0.02mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.仕上り厚み指定["0.15±0.03mm"].value}>0.15±0.03mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.仕上り厚み指定["0.18±0.05mm"].value}>0.18±0.05mm</Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </FieldSet>
      <OneClickFieldMessages error={仕上り厚み指定.error} />
      <Spacer size={8} />
      <FieldSet legend={`接着面（${number}箇所目）`}>
        <RadioGroup name={接着面.name} selectedValue={接着面.selectedValue} onChange={handlers.radio}>
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.接着面[`パターン面と同じ面(L1面)(${id})`].value}>
              {resolveAdhesiveSideName(ESTIMATE_CONSTANT.接着面[`パターン面と同じ面(L1面)(${id})`].value, values)}
            </Radio>
            <Radio value={ESTIMATE_CONSTANT.接着面[`パターン面とは逆の面(Ln面)(${id})`].value}>
              {resolveAdhesiveSideName(ESTIMATE_CONSTANT.接着面[`パターン面とは逆の面(Ln面)(${id})`].value, values)}
            </Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </FieldSet>
      <OneClickFieldMessages error={接着面.error} />
    </>
  )
}
